export const services = [
  'contactPage.contactUs.services.one',
  'contactPage.contactUs.services.two',
  'contactPage.contactUs.services.three',
  'contactPage.contactUs.services.four',
  'contactPage.contactUs.services.five',
  'contactPage.contactUs.services.six',
];
